import React from 'react';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { PAGE_CONFIG } from './pageConfig';

const reqParams = '/engagement/rateReturn'
const NightingaleRetention = () => {
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={PAGE_CONFIG}/>
    </>
  );
};

export default NightingaleRetention;
